import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'

export default class BlockHome extends Component {

    onScroll(e) {
        this._scroll = e.animatedScroll ;
        // this.style.opacity = 1 - Math.min(1, this._scroll / (window.innerHeight * 0.5));
    }

    created() {
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this); 
        this._scroll   = 0;
    }
    

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    attached() {
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);
        this.$blockGl = this.querySelector('block-gl')
        Lenis?.on?.('scroll', this.onScroll);
    }
    
    update() {
        this.$blockGl?.setColors?.({
            backgroundColor: this.stopped ? '#381e33' : '#FFAAA5',
            outputColor:     this.stopped ? '#F6C7FF' : '#FFD198',
        });
    }

}

customElements.define('block-home', BlockHome);